import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgDangerTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9.247 2.187.657.361-.657-.361Zm3.505 0-.658.361.658-.361Zm7.617 13.85.657-.362-.657.361Zm-18.74 0-.657-.362.657.361ZM11.75 7a.75.75 0 0 0-1.5 0h1.5Zm-1.5 4a.75.75 0 0 0 1.5 0h-1.5Zm1.5 3.988a.75.75 0 0 0-1.5 0h1.5Zm-1.5.012a.75.75 0 0 0 1.5 0h-1.5Zm8.368 3.25H3.382v1.5h15.235v-1.5Zm-16.33-1.852 7.617-13.85-1.314-.723-7.618 13.85 1.314.723Zm9.808-13.85 7.617 13.85 1.314-.723-7.617-13.85-1.315.723Zm-2.191 0a1.25 1.25 0 0 1 2.19 0l1.315-.723c-1.045-1.9-3.775-1.9-4.82 0l1.315.723Zm8.713 17.202c2.091 0 3.417-2.242 2.41-4.075l-1.315.723a1.25 1.25 0 0 1-1.095 1.852v1.5Zm-15.235-1.5a1.25 1.25 0 0 1-1.096-1.852l-1.314-.723c-1.008 1.833.318 4.075 2.41 4.075v-1.5ZM10.249 7v4h1.5V7h-1.5Zm0 7.988V15h1.5v-.012h-1.5Z",
  fill: "#B92624"
})));

export { SvgDangerTriangle as default };
